import { Next } from '@securitize/ui-components';

export const loginNext = new Next('/authorize', 'USER_LOGIN', { method: 'post' });
export const sessionNext = new Next('/session', 'USER_SESSION');
export const logoutNext = new Next('/logout', 'USER_LOGOUT');
